import { Icon, Link } from "@oysterhr/ui"
import { PropsWithChildren } from "react"
import { useNavigate } from "react-router-dom"
import classNames from "classnames"

interface BackProps {
  to?: string
  onClick?: () => void
  noMargin?: boolean
  mobileVisible?: boolean
}

export const Back = ({
  to,
  onClick,
  noMargin,
  children,
  mobileVisible,
}: PropsWithChildren<BackProps>) => {
  const navigate = useNavigate()
  if (!to && !onClick) {
    return null
  }

  const onBackDefault = () => to && navigate(to)
  return (
    <Link
      as="button"
      startAdornment={<Icon name="ArrowLeft" />}
      className={classNames("md:flex", {
        "ml-8": !noMargin,
        hidden: !mobileVisible,
      })}
      onClick={onClick || onBackDefault}
      type="button"
    >
      {children || "Back"}
    </Link>
  )
}
